module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /home/svc.teamcity.prd/BuildAgent/work/80562bb639a6ae70/node_modules/core-js/modules/_iter-step.js
// module id = w/BM
// module chunks = 8